/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import XHR from "i18next-xhr-backend";
import { text_en } from "./locales/en/translation";
import { text_bi } from "./locales/bi/translation";
import {StorageModule} from "@vlinder-web/storage-module-react";

const storageSrv = StorageModule.getInstance();

const localLan = storageSrv.get("language", "local");


i18n
  .use(XHR)
  .use(LanguageDetector)
  .init({
    debug: false,
    lng: localLan,
    fallbackLng: localLan,
    interpolation: {
      escapeValue: false,
    },
returnObjects:true,
    resources: {
      en: {
         translations: text_en,
      },
      bi: {
        translations: text_bi,
      }
    },
    ns: ["translations"],
    defaultNS: "translations",
  })

export default i18n;
